import ProductCard     from "components/Product/ProductCard"
import ProductListItem from "components/Product/ProductListItem"

import _            from "lodash"
import { observer } from "mobx-react"

import CategoryShortcuts                                                                             from "plugin/CategoryShortcuts/CategoryShortcuts"
import CategoryDropdown                                                                              from "components/Category/CategoryDropdown"
import queryString                                                                                   from "qs"
import React, { Component, useEffect }                                                               from "react"
import { Link, NavLink, withRouter }                                                                 from "react-router-dom"
import { Accordion, Button, Card, Container, Dropdown, Form, Icon, Menu, Pagination, Radio, Sticky, Divider } from "semantic-ui-react"
import shop                                                                                          from "shop/shop"
import categoryStore                                                                                 from "stores/categoryStore"
import cmsStore                                                                                      from "stores/cmsStore"
import MediaQuery                                                                                    from "react-responsive"
import Tooltips from "../components/Tooltips/Tooltips"
import productStore from "stores/productStore"

import colors                 from "style/colors"

import "style/FilterPage.scss"
import historyStore           from "stores/historyStore"
import WordPress              from "WordPress"
import { slugify }            from "sdk/slugify";
import { SEOCategory }        from "../../../components/SEO";
import WordPressShopComponent from "../../../components/WordPressShopComponent/WordPressShopComponent";
import { trackCategoryView  } from "components/tracking/Tracking";

const lastFilters = {}

@observer
export default class FilterPage extends Component {
  
  state = {
    products: [], showSidebar: true, size: 0, showDrawer: false,
    showToolTip: localStorage.getItem("categoryPageToolTip") === "true" ? true : false,
  }
  
  handleClear = () => {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    const reset = {
      dir: query.dir, count: query.count, sort: query.sort, 
    }
    this.props.history.replace( { search: queryString.stringify( reset ) } )
  }
  
  componentWillReceiveProps( props ) {
    const { categories } = props.match.params
    const { search } = props.location
    console.log("FilterPage::componentWillReceiveProps", categories,"search", search,"props", props)
    if ( this.search !== search || categories !== this.categories ) {
      this.load( props )
    }
    
    this.categories = categories
    this.search = search
  }
  
  componentDidMount() {
    console.log("FilterPage::componentDidMount", this.props.match.params.categories, this.props.location.search)
    localStorage.setItem("categoryPageToolTip", "true");
    this.props.location.search = "?sort=des&dir=asc" || ""
    const query = queryString.parse( this.props.location.search.substr( 1 ) ) || {}
    if ( !query.sort ) {
      const search = getDefaultFilterSearch( query )
      return this.props.history.replace( { search } )
      // return <Redirect replace to={{search: getDefaultFilterSearch()}} />
    }
    this.load()
  }
  
  componentDidUpdate() {
    _.debounce( this.load, { trailing: true }, 250 )
  }
  
  toggleSidebar = () => {
    this.setState( { showSidebar: !this.state.showSidebar } )
  }
  
  async fetchCategoryPage( collectionId ) {
    try {
      let result = await shop.fetch( `/wp/wp-json/wp/v2/shop-category?slug=${collectionId}` )
      if ( result.length > 0 ) {
        this.setState( { categoryPage: result[ 0 ] } )
      } else {
        this.setState( { categoryPage: 0 } )
      }
    }
    catch (err) {
      console.error( "Error Fetching shop-category", err )
      this.setState( { categoryPage: 0 } )
    }
  }
  
  load = ( props = this.props, categorySubId ) => {
    this.setState( { loading: true } )
    console.log("FilterPage::load", props, categorySubId)
    const query = queryString.parse( props.location.search.substr( 1 ) )
    let { categories = "" } = props.match.params
    console.log("categoryID categories:", categories)
    if(shop.config.plugin && shop.config.plugin.SEOCategoryLink){
      const seoCategory = categoryStore._SEOCategoryTree['/' + categories];
      if(seoCategory === undefined){
        this.props.history.push('/home');
        return null
      }
      categories = seoCategory.catpath.substring(1);
      console.log("SEO Category Tree", seoCategory,categories)
    }
    const parentCategories = categories.split( "/" )
    const categoryId = decodeURIComponent(parentCategories.pop())
    const category = categoryStore.categoriesById.get( categoryId )

    //GTM Event Trigger
    //console.log("GTM Event Trigger", categoryId, category.title);
    if(categoryId && category && category.title){
      trackCategoryView (categoryId, category.title);
    }
    

    // TODO: NOT EVERY CATEGORY STORE SUPPORTS THIS
    // categoryStore.fetchCategoryMeta && categoryStore.fetchCategoryMeta( categoryId )
    
    const { page = 1, count = shop.config.standards.ITEMS_PER_PAGE } = query
    let filters = []
    const fields = _.pick( query, shop.config.pickFilter )
    const filterSize = _.size( fields )
    
    _.forEach( fields, ( value, key ) => {
      
      // MULTIFILTERS ARE ADDED AS "OR"
      if ( Array.isArray( value ) ) {
        let queryFilters = value.map( v => {
          return {
            op: "equals", extra: true, field: key, value: v
          }
        } )
        
        let combinedFilter = { "or": queryFilters }
        filters.push( combinedFilter )
        
      } else {
        let filter = {
          op: "equals", extra: true, field: key, value: value
        }
        filters.push( filter )
      }
    } )
    
    // Only hide variants if we don't search by filter
    // i.e. user searches for color only available on variants
    if ( cmsStore.config.plugin.hideVariants ) {
      // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
      let noVariants = {
        op: "equals", field: "type", value: "1"
      }
      const singleItems = { "field": "mainArticle", "op": "equals", "value": "" } //CollectionPage mainArticle = mainart
      let combinedFilter = [{ "or": [singleItems, noVariants] }]
      filters = filters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
    }

    console.log("categoryID", categoryId)
    if ( categoryId ) {
      this.fetchCategoryPage( categoryId )
      
      productStore.fromCategory( categoryId, {
        value: "%%",
        dir: query.dir || shop.config.standards.DIR || "asc",
        sort: query.sort || shop.config.standards.SORT || "des",
        page,
        count: count || shop.config.standards.ITEMS_PER_PAGE,
      }, filters ).then( res => {
        if ( !res.products.length ) {
          
          let catQuery = {
            value: "%%",
            dir: query.dir || shop.config.standards.DIR || "asc",
            sort: query.sort || shop.config.standards.SORT || "des",
            page,
            count: count || shop.config.standards.ITEMS_PER_PAGE,
          }
          
          let additionalFilters = filters.filter( e => e.field !== "type" )
          
          // console.info( "NO VARIANTS FOUND - FALLBACK TO 'SHOW ALL'" )
          return productStore.fromCategory( categoryId, catQuery, additionalFilters )
                             .then( res => {
                               let { products } = res
                               if ( products.length === 0 ) {
                                 if ( products.length === 0 && shop.config.collections.showProductsFromSubCategories ) {
                                   // get products from all child categories
                
                                   const mapChildren = cat => {
                                     if ( cat.children.length > 0 ) return _.map( cat.children, mapChildren )
                                     return cat.map_id
                                   }
                
                                   const ids = _.flatten( category && category.children.map( mapChildren ) )
                                   if ( ids.length > 0 ) {
                                     return productStore.fromCategory( ids, catQuery, additionalFilters )
                                   }
                                 }
                               }
                               return res
                             } )
        }
        return res
      } )
                  .then( res => {
                    let { products, meta = {}, fields, size } = res
                    fields = fields || meta.fields
                   // console.log( "NEW FILTER FIELDS", categoryId, Object.keys( fields ).length, { fields } )
                    this.setState( { products, category, fields, size, meta, filterCount: fields && fields.length, loading: false } )
                    return res
                  } )
    } else {
      productStore.query( {
                            value: "%%",
                            filter: [...filters],
                            dir: query.dir || shop.config.filter_defaults.sort || "des",
                            sort: query.sort || shop.config.filter_defaults.sort,
                            page,
                            count: count || shop.config.standards.ITEMS_PER_PAGE,
                          } )
                  .then( res => {
                    lastFilter = this.props.location.search
                    let { products, size } = res
                    this.setState( { products, size, filterCount: fields && fields.length, loading: false } )
                  } )
    }
  }

  handleSortChange = ( sort ) => {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    query.sort = sort
    this.props.history.replace( { search: queryString.stringify( query ) } )
  }
  
  handleCountChange = ( count ) => {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    query.count = count
    this.props.history.replace( { search: queryString.stringify( query ) } )
  }
  
  handleDirectionChange = ( dir ) => {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    query.dir = dir
    this.props.history.replace( { search: queryString.stringify( query ) } )
  }
  
  render() {
    let { categories = "" } = this.props.match.params
    if(shop.config.plugin && shop.config.plugin.SEOCategoryLink){
      const seoCategory = categoryStore._SEOCategoryTree['/' + categories];
      console.log("seoCategory", seoCategory, categoryStore, categories)
      if(seoCategory === undefined){
        this.props.history.push('/home');
        return null;
      }
      categories = seoCategory.catpath.substring(1);
      console.log("SEO Category Tree", seoCategory,categories)
    }
    const { useEditor } = cmsStore

    const parentCategories = categories.split( "/" )
    const depth = parentCategories.length
    const categoryId = parentCategories.pop()
    const category = categoryStore.categoriesById.get( categoryId )
    let path = shop.getCategoryPath( categoryId )
    console.log("categoryID PATH: ", path, category)

    let showProductSearch = true
    const query = queryString.parse( this.props.location.search.substr( 1 ) ) || {}
    const view = query.view || shop.config.filter_defaults.view || "grid"
    
    const { sort = shop.config.filter_defaults.sort } = query
    const { dir = shop.config.filter_defaults.dir || "asc" } = query
    
    let count = getFilterCount( query )
    const { products, showSidebar, showDrawer, size, showToolTip } = this.state
    
    let loading = productStore.loading || this.state.loading
    
    let filterFields = categoryStore.rootFields
    if ( this.state.meta ) {
      filterFields = this.state.meta.fields
    }
    
    if ( category ) {
      console.log("category", category)
      filterFields = category.meta.fields || category.meta.submeta.fields
      if ( category.children.length >= 1  || category.children.length === 0 ) {
        console.log("category.children.length", category.children.length)
        showProductSearch = true
      }
    }
    console.log("showProductSearch", showProductSearch, categoryId)
    
    // only show products on subcategories AND SALE and NEUHEITEN.e.g. no products on overview-categories
    if ( depth <= 0 && (categoryId !== "SALE" && categoryId !== "NEU" && categoryId !== "53" && categoryId !== "58" && categoryId !== "227" && categoryId !== "214" && categoryId !== "215" ) ) {
      showProductSearch = false
    }
    // console.log( { categoryId, depth, showProductSearch } )
    
    // if ( !query.sort ) {
    // 	return <Redirect replace to={{search: getDefaultFilterSearch()}} />
    // }
    let page = cmsStore.contentByCategory.get( `${categoryId}` )
    
    const currentSearch = queryString.stringify( {
                                                   referrerTitle: category && category.title, referer: `${this.props.location.pathname}${this.props.location.search}`
                                                 } )
    
    
    const filterItems = Object.entries( query )
    return <div className={"FilterPage"}>
      {showToolTip && <Tooltips toolTipToBeShown={"categoryPageToolTip"}/>}
      <SEOCategory category={category} seo={this.state.categoryPage}/>
      {/*<WordPressShopComponent style={{backgroundImage: `url("/herenzVectorBG.PNG")`}} key={`category-${categoryId}`} slug={`category-${categoryId}-top`}/>
      {<div className="" style={{ display: "absolute", backgroundColor: "#369678", zIndex: "-10"}}>
      <svg xmlns="http://www.w3.org/2000/svg" height="423" viewBox="0 0 423 423" fill="#369678">
        <path d="M214 211.5L0 423L0 0L214 211.5Z" fill="#419F81"/>
        <path d="M214 213L0 0L423 0L212.5 213Z" fill="#389074"/>
        <path d="M423 423L0 423L423 0L423 423Z" fill="#369678"/>
      </svg>
      
      </div>*/}

      <div id="wrapper2">
    <div className="content2">    
      <WordPressShopComponent key={`category-${categoryId}`} slug={`category-${categoryId}-top`}/>
    </div>
</div>
      {/* FILTER DRAWER MOBILE*/}
      <MediaQuery maxWidth={1024}>
        <div style={{zIndex: "1000"}}
          className={`FilterDrawer fixed z-9 bottom-0 right-0 left-0 animate ${showDrawer ? "fadeInUp" : "slideOutDown"}`}>
          <div className="wrapper">

            <Sticky>
              <div className="left-0 right-0 pa2 bg-white flex justify-between items-center">
                <div className="animate fadeInDown w-100">
                  <Button floated="right" icon={"chevron down"} onClick={() => {
                    this.setState( { showDrawer: !showDrawer } )
                  }}/>
                  <div
                    className="pt2 mt1 pl3 black-60 f6">{size} {translate( "Produkte gefunden" )}</div>
                </div>
              </div>
            </Sticky>
            
            <FilterNavigation
                  filterFieldsCurrentSearch={this.state.fields}
                  location={this.props.location}
                  category={category}
                  key={categoryId}
                  filterFields={filterFields}
                  query={query}
                  className="pb3"/>
          </div>
        </div>
        
        <div className="fixed bottom-1 left-1 right-1 z-5 tc">
          <Button primary circular
                  size={"small"}
                  onClick={() => {
                    this.setState( { showDrawer: !showDrawer } )
                  }}
          ><Icon name="filter"/>{count !== 0 ? count : ""} FILTER </Button>
        </div>
      </MediaQuery>
      
      
      <Container>
        <MediaQuery minWidth={"1100px"}>

        <div className="pt3 pb3">
            <Menu borderless secondary pointing className={"w-100 pb3"} style={{maxHeight: "50px", border: "none"}}>
              
              {/*<CategoryDropdown category={category} current={`/collection/${categories}`}/>
              {path.map( ( item, index ) => <Menu.Item key={item.title} as={NavLink} to={item.link}
                                                       exact>{item.title}</Menu.Item> )}*/}
              
              {/*<Menu.Item>*/}
              {/*<Input placeholder="Suche"/>*/}
              {/*</Menu.Item>*/}
              <Menu.Menu position="left" className="ba b--black-20 black-70 mt2" style={{borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px", backgroundColor: "#ffffff"}}>
              <Menu.Item as={NavLink} to={"/home"} activeStyle={{ color: "#369678", textDecoration: "none", border: "none" }}>
                <Icon className="home"/>  
                </Menu.Item>
                {path.map( ( item, index ) => <Menu.Item activeStyle={{ color: "#369678", textDecoration: "none" , border: "none"}} key={item.title} as={NavLink} to={item.link}
                                                       exact>{item.title}</Menu.Item> )}
              </Menu.Menu>

              <Menu.Menu position="right" >
              <Menu.Item className="ba b--black-20 black-70 mt2" style={{border: "0.5px solid rgba(0, 0, 0, 0.2)",  borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px", backgroundColor: "#ffffff"}}>
                  <div className="f6"><SortBy sort={sort} onChange={this.handleSortChange}/></div>
                </Menu.Item>
                {dir === "asc" && <Menu.Item className="ba b--black-20 " style={{border: "0.5px solid rgba(0, 0, 0, 0.2)",  borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px", backgroundColor: "#ffffff"}}
                 onClick={() => {
                  this.handleDirectionChange( "desc" )
                }} >
                    <Icon className="sort amount up"> </Icon>
                  </Menu.Item>}
                {dir === "desc" && <Menu.Item className="ba b--black-20 " style={{border: "0.5px solid rgba(0, 0, 0, 0.2)", borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px", backgroundColor: "#ffffff"}}
                 as={Button} onClick={() => {
                  this.handleDirectionChange( "asc" )
                }}> 
                  <Icon className="sort amount down"> </Icon>
                </Menu.Item>}
              </Menu.Menu>


            </Menu>
          </div>
        
        </MediaQuery>
        <MediaQuery maxWidth={"1099px"}>
        <div className="pt3 pb3">
{/*        <Menu borderless secondary pointing className={"w-100 pb3"} style={{maxHeight: "50px", border: "none"}}>
        <Menu.Menu position="left" className="ba b--black-20 black-70 mt2" style={{borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px", backgroundColor: "#ffffff"}}>
              <Menu.Item as={NavLink} to={"/home"} activeStyle={{ color: "#369678", textDecoration: "none", border: "none" }}>
                <Icon className="home"/>  
                </Menu.Item>
                {path.map( ( item, index ) => <Menu.Item activeStyle={{ color: "#369678", textDecoration: "none" , border: "none"}} key={item.title} as={NavLink} to={item.link}
                                                       exact>{item.title}</Menu.Item> )}
              </Menu.Menu>
              </Menu> */}
            <Menu borderless secondary pointing className={"w-100 pb3"} style={{maxHeight: "50px", border: "none"}}>
              
              {/*<CategoryDropdown category={category} current={`/collection/${categories}`}/>
              {path.map( ( item, index ) => <Menu.Item key={item.title} as={NavLink} to={item.link}
                                                       exact>{item.title}</Menu.Item> )}*/}
              
              {/*<Menu.Item>*/}
              {/*<Input placeholder="Suche"/>*/}
              {/*</Menu.Item>*/}


              <Menu.Menu position="right" >
              <Menu.Item className="ba b--black-20 black-70 mt2" style={{border: "0.5px solid rgba(0, 0, 0, 0.2)",  borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px", backgroundColor: "#ffffff"}}>
                  <div className="f6"><SortBy sort={sort} onChange={this.handleSortChange}/></div>
                </Menu.Item>
                {dir === "asc" && <Menu.Item className="ba b--black-20 " style={{border: "0.5px solid rgba(0, 0, 0, 0.2)",  borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px", backgroundColor: "#ffffff"}}
                 onClick={() => {
                  this.handleDirectionChange( "desc" )
                }} >
                    <Icon className="sort amount up"> </Icon>
                  </Menu.Item>}
                {dir === "desc" && <Menu.Item className="ba b--black-20 " style={{border: "0.5px solid rgba(0, 0, 0, 0.2)", borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px", backgroundColor: "#ffffff"}}
                 as={Button} onClick={() => {
                  this.handleDirectionChange( "asc" )
                }}> 
                  <Icon className="sort amount down"> </Icon>
                </Menu.Item>}
              </Menu.Menu>


            </Menu>
          </div>
        </MediaQuery>

        
        {/* WORDPRESS CONTENT*/}
        {page && <div className="pt3 pb2"><WordPress page={page}/></div>}
        
        {(shop.config.plugin[ "categoryShortcuts" ] && depth < 3) && <div className="pl3 pt3">
          {<CategoryShortcuts category={category}/>}
          {/*<div>
            {category && category.children && category.children.map(child => (
              <Button key={child.map_id}  onClick={() => this.handleCategoryClick(this.props, child.map_id)} style={{ margin: "5px" }}>
                <p>{child.title}</p>
              </Button>
            ))}
          </div>*/}
          {console.log("categoryID", category)}
        </div>}
        
        {showProductSearch && <React.Fragment>
          <div className="pt2 pb3">
            <Menu borderless secondary pointing className={"w-100"}>
              <MediaQuery minWidth={"768px"}>
                <div className="flex flex-row items-center pb1 flex-wrap pt2 nt1" style={{ maxWidth: "65vw" }}>
                  <div className="b black-80 f5 mr2 mb2 ">{translate( "Filter" )}</div>
                  {
                    filterItems.map( ( [key, value] ) => {
                      if ( key === "page" ) return null
                      if ( key === "sort" ) return null
                      if ( key === "dir" ) return null
                      const filterObject = this.state.fields && this.state.fields[ key ]
                      if ( !filterObject ) return null
                      const displayName = translate( filterObject.text )
                      const searchObject = { ...query, [ key ]: null }
                      for ( let searchKey in searchObject ) {
                        
                        if ( searchObject[ searchKey ] === null ) delete searchObject[ searchKey ]
                      }
                      const search = queryString.stringify( searchObject )
                      //console.log( "FILTER SEARCHKEY", value )
                        if (Array.isArray(value)) {
                        value = value.map(v => v + " ");
                        } else {
                        value += " ";
                        }
                      return <div className="mr1 mb2" key={key}>
                        <Button as={Link}
                                to={{ search }}
                                circular basic size="small" title={displayName} className="hide-child">
                          <div className="flex flex-row items-center justify-center">
                            <div className="b pr1">{displayName}: {value}</div>
                            <div className="child"><Icon name="times"/></div>
                          </div>
                        </Button>
                      </div>
                    } )
                  }
                </div>
              </MediaQuery>
              {/*<MediaQuery maxWidth={"1099px"}>*/}
              {/*  <Menu.Item*/}
              {/*    className="filter-toggl"*/}
              {/*    style={{ width: "190px" }}>*/}
              {/*    <div className="f5 "><Link to={{ search: this.props.location.search }}*/}
              {/*                               onClick={this.toggleSidebar}>*/}
              {/*      {showSidebar && <Icon name="angle left"/>}*/}
              {/*      {!showSidebar && <Icon name="angle right"/>}*/}
              {/*      {translate( "Filter" )} {count > 0 && <span>{translate( "aktiv" )} <b>({count})</b></span>}</Link>*/}
              {/*      {(count > 0 && !loading) && <Button basic className="clear-filter clear-filter--all primary " circular icon={"close"}*/}
              {/*                                          size="tiny" onClick={this.handleClear}/>}*/}
              {/*      {loading && <Button basic className="clear-filter clear-filter--all" circular loading icon={"close"}*/}
              {/*                          size="tiny"/>}*/}
              {/*    </div>*/}
              {/*  </Menu.Item>*/}
              {/*</MediaQuery>*/}
              {/*<Menu.Menu position="right">*/}
              {/*/!*<Menu.Item active as={Link} to="./">Alles</Menu.Item>*!/*/}
              {/*/!*<Menu.Item as={Link} to="./">Basic</Menu.Item>*!/*/}
              {/*/!*<Menu.Item as={Link} to="./">Saison</Menu.Item>*!/*/}
              {/*/!*<Menu.Item as={Link} to="./">Sale</Menu.Item>*!/*/}
              {/*</Menu.Menu>*/}

              <Menu.Menu position="right">

                <Menu.Item>
                  <div className="f6"><SelectCount count={query.count}
                                                   onChange={this.handleCountChange}/></div>
                </Menu.Item>

                <Menu.Item as={Link} active={view === "grid"}
                           to={{ search: queryString.stringify( { ...query, view: "grid" } ) }}
                           icon={"th"}/>
                {<MediaQuery minWidth={768}><Menu.Item as={Link} active={view === "list"}
                           to={{ search: queryString.stringify( { ...query, view: "list" } ) }}
                           icon={"th list"}/></MediaQuery> }
              </Menu.Menu>
            </Menu>
          </div>
          
          
          <div className="flex ">
            <MediaQuery minWidth={1024}>
              <div className={`catalog-sidebar ${showSidebar ? " fadeInLeft" : "animate fadeOutLeft"}`}>
                
                <FilterNavigation
                  filterFieldsCurrentSearch={this.state.fields}
                  location={this.props.location}
                  category={category}
                  key={categoryId}
                  filterFields={filterFields}
                  query={query}
                  className="pb3"/>
                
                {/*KATEGORIES*/}
                {/*<NavigationSidebar category={category}/>*/}
              </div>
            </MediaQuery>
            
            <div className="w-100 ">
              <div className="tc pb3">
                <FilterPagination query={query} size={size}/>
              </div>
              <MediaQuery minWidth={1100}>
              {!loading && view === "grid" && <div key={this.props.location.pathname + this.props.location.search}
                                                   className="catalog-products pb4">
                <Card.Group itemsPerRow={showSidebar ? 4 : 5} doubling>
                  {products.map( product => <ProductCard key={product.map_id} product={product}/> )}
                </Card.Group>
              </div>}
              </MediaQuery>
              <MediaQuery maxWidth={1099} minWidth={768}>
                <div className="catalog-products pb4">
                  <Card.Group  itemsPerRow={2} doubling>
                    {products.map( product => <ProductCard key={product.map_id} product={product}/> )}
                  </Card.Group>
                </div>
              </MediaQuery>
              <MediaQuery maxWidth={767}>
                              {!loading && view === "grid" && <div key={this.props.location.pathname + this.props.location.search}
                                                   className="catalog-products pb4">
                <Card.Group className="flex flex-column items-center justify-center" itemsPerRow={1} doubling>
                  {products.map( product => <ProductCard key={product.map_id} product={product}/> )}
                </Card.Group>
              </div>}
              </MediaQuery>
              
              {!loading && view === "list" && <div key={this.props.location.pathname + this.props.location.search}
                                                   className="catalog-products catalog-products--list">
                {products.map( ( product, index ) => <ProductListItem
                  index={index}
                  key={product.map_id}
                  product={product}
                  search={currentSearch}/> )}
              </div>}
              {showProductSearch && <div className="tc pt4 pb4">
        <FilterPagination query={query} size={size}/>
      </div>}
            </div>
          
          </div>
        </React.Fragment>}
      
      </Container>
      

    </div>
  }
}

@withRouter
class FilterForm extends React.Component {
  
  handleChange = ( e, { value } ) => {
    const { type } = this.props
    const multi = type === "Checkbox"
    const { name, query } = this.props
    
    const oldValue = query[ name ] || []
    
    if ( multi ) {
      if ( oldValue.includes( value ) ) {
        query[ name ] = oldValue.filter( e => e !== value )
      } else {
        query[ name ] = [...oldValue, value]
      }
    } else {
      if ( oldValue.includes( value ) ) {
        delete query[ name ]
      } else {
        query[ name ] = [value]
      }
    }
    
    query.page = 1
    this.props.history.replace( { search: queryString.stringify( query ), state: { preventScrollToTop: true } } )
  }
  
  render() {
    const { query, name, options, type = "Checkbox", facettes } = this.props
    const multi = type === "Checkbox"
    const values = query[ name ] || []
    const valueById = {}
    if ( multi ) {
      values.forEach( e => {
        valueById[ e ] = true
      } )
    } else {
      valueById[ values ] = true
    }
    
    
    const FilterComponent = Filters[ type ] || Filters[ "Checkbox" ]
    return (<Form >
      <FilterComponent
        facettes={facettes}
        onChange={this.handleChange}
        options={options}
        multi={multi}
        valueById={valueById}
        query={query}/>
    </Form>)
  }
}

const Filters = {
  Checkbox: function CheckboxFilter( { onChange, facettes, options, multi, valueById, query } ) {
    return <div>
      <Form.Group grouped>
        {options.map( option => {
          const hasFacettes = facettes && facettes[ option ]
          const countAfter = facettes && facettes[ option ]
          const facetteLabel = hasFacettes ? ` (${countAfter ? countAfter.value : ""})` : ""
          let isChecked = query[ name ] === option
          
          if ( !countAfter ) {
            // hide empty
            return null
          }
          
          if ( multi ) {
            isChecked = valueById[ option ]
          }
          
          if ( name === "ArtikelFarbe" ) {
            const color = colors[ option ]
            return <div
              key={option}
              className="color-filter"
            >
              <div className={`color-marker ${query[ name ] === option && "active"}`}
                   style={{ backgroundColor: color }}/>
              <Form.Checkbox className="fw6"
                onChange={onChange} label={option} type="checkbox" checked={query[ name ] === option}
                value={option}/>
            </div>
          }
          return <Form.Checkbox className="fw6"
            disabled={hasFacettes && countAfter <= 0}
            key={option} onChange={onChange} label={`${option}${facetteLabel}`} checked={isChecked}
            value={option}/>
        } )}
      </Form.Group>
    </div>
  }, Radio: function RadioFilter( { onChange, facettes, options, multi, valueById, query } ) {
    return <div>
      <Form.Group grouped>
        {options.map( option => {
          const hasFacettes = facettes && facettes[ option ]
          const countAfter = facettes && facettes[ option ]
          const facetteLabel = hasFacettes ? ` (${countAfter})` : ""
          let isChecked = valueById[ option ]
          if ( name === "ArtikelFarbe" ) {
            const color = colors[ option ]
            return <div
              key={option}
              className="color-filter"
            >
              <div className={`color-marker ${query[ name ] === option && "active"}`}
                   style={{ backgroundColor: color }}/>
              <Radio
                onChange={onChange} label={option} type="radio" checked={query[ name ] === option}
                value={option}/>
            </div>
          }
          return <Form.Radio key={option} onChange={onChange} label={`${option}${facetteLabel}`} checked={isChecked}
                             value={option}/>
        } )}
      </Form.Group>
    
    </div>
  }
}


const getFilterCount = ( query ) => {
  let count = _.size( query )
  if ( query.sort ) count--
  if ( query.dir ) count--
  if ( query.view ) count--
  if ( query.page ) count--
  return count
}

@withRouter
class FilterPagination extends Component {
  
  handleClick = ( e, data ) => {
    const { query } = this.props
    const { activePage } = data
    query.page = activePage
    this.props.history.replace( { search: queryString.stringify( query ) } )
  }
  
  render() {
    const { size, query } = this.props
    const { count = shop.config.standards.ITEMS_PER_PAGE || 24, page = 1 } = query
    const totalPages = Math.ceil( size / count )
    if ( totalPages <= 1 ) return null
    return <Pagination 
      className={"FilterPagination"}
      onPageChange={this.handleClick}
      activePage={page}
      ellipsisItem={null}
      firstItem={null}
      lastItem={null}
      siblingRange={1}
      totalPages={totalPages}
    />
  }
}


const FilterNavigation = ( { submeta = false, filterFieldsCurrentSearch, searchString = "DEFAULT", filterFields, query, location, defaultOpen = false, className = "", category } ) => {
  const categoryId = category && category.map_id
  
  const [baseFields, setBaseFilter] = React.useState( filterFieldsCurrentSearch || filterFields )
  const [iteration, setIteration] = React.useState( 0 )
  const [currentCategoryId, setCurrentCategory] = React.useState( categoryId )
  
  const [sortedFields, setSortedFields] = React.useState( {} )
  const [currentFilterFields, setCurrentFilterFields] = React.useState( false )
  
  // console.log("FILTER: CATEGORY", categoryId, currentCategoryId)
  // console.log("FILTER: BASE", Object.keys(baseFields).length)
  // console.log("FILTER: FILTERFIELDS", Object.keys(filterFields).length)
  // console.log("FILTER: FILTERFIELDSCURRENTSEARCH", Object.keys(filterFieldsCurrentSearch || {}).length)
  
  useEffect( () => {
    console.log("categoryID: ", categoryId, currentCategoryId)
    if ( categoryId !== currentCategoryId ) {
      if ( filterFieldsCurrentSearch ) {
        setBaseFilter( filterFieldsCurrentSearch )
        setCurrentFilterFields( false )
        // console.log("RESET BASE FILTER", categoryId, Object.keys(filterFields).length, searchString, categoryId, {filterFields})
        setCurrentCategory( categoryId )
        setIteration( 0 )
      }
      
    }
    
  }, [categoryId, filterFieldsCurrentSearch] )
  
  
  useEffect( () => {
    // console.log( "RESET filterFieldsCurrentSearch", filterFieldsCurrentSearch, baseFields )
    let nextFilterFields = filterFieldsCurrentSearch || filterFields
    const target = {}
    mergeDeep( target, baseFields, nextFilterFields )
    setCurrentFilterFields( target )
  }, [filterFieldsCurrentSearch] )
  
  // // console.log( { baseFields } )
  useEffect( () => {
    console.log( "RESET FILTER NAVIGATION", { location, category, currentFilterFields, baseFields, filterFields, filterFieldsCurrentSearch } )
    if ( !location || !category ) return
    const link = location.pathname + location.search
    historyStore.set( {
                        key: 0, content: category.desc.short_des, link
                      } )
    // console.log( "RESET HAS DATA", { currentFilterFields, baseFields, filterFields, filterFieldsCurrentSearch } )
    
    
    categoryStore.loadTranslatedFieldsForCategory( category.map_id )
                 .then( res => {
                   setIteration( iteration + 1 )
                   let withData = Object.keys( currentFilterFields ).map( fieldName => {
                     const fieldMeta = currentFilterFields[ fieldName ]
                     let fieldDatas = cmsStore.config[ fieldName ] || []
                     let fieldData = fieldDatas[ 0 ] || {}
                     let displayName = fieldMeta.text || fieldData.text || fieldData.text || fieldName
                     return { fieldName, fieldData, displayName, filterValue: currentFilterFields[ fieldName ] }
                   } )
      
                   const sortedFilterFields = withData.sort( ( a, b ) => {
                     let sortA = Infinity
                     let sortB = Infinity
                     sortA = Number( a.sort )
                     sortB = Number( b.sort )
                     if ( isNaN( sortA ) ) sortA = a.displayName
                     if ( isNaN( sortB ) ) sortB = b.displayName
                     if ( sortA === sortB ) return 0
                     return sortA > sortB ? 1 : -1
                   } )
      
                   const sortedFields = {}
      
                   sortedFilterFields
                     .forEach( field => {
                       let text = field.fieldData && field.fieldData.text
                       sortedFields[ text || field.fieldName ] = field
                     } )
      
                   setSortedFields( sortedFields )
                 } )
    
  }, [location, baseFields, currentFilterFields] )
  
  // // console.log( { sortedFields } )
  return <div className={`FilterNavigation ${className}`}>
    <Accordion as={Menu} vertical>
      {_.map( sortedFields, ( filter ) => {
        let value = filter.filterValue
        /// ONLY DISPLAY ENTRIES W/ MORE THAN 1 VALUE
        const keys = Object.keys( value.values )
        // if ( keys.length <= 1 ) return null
        
        let key = filter.fieldName
        let hidden = false
        // SKIP FILTERS NOT IN CONFIG
        if ( shop.config.pickFilter && shop.config.pickFilter.indexOf( key ) < 0 ) {
          // console.info( `Skipping filter for ${key}` )
          hidden = true
          // return null
        }
        
        let options = []
        if ( value.values && typeof value.values === "object" ) {
          // data from meta.fields
          options = Object.keys( value.values )
        } else {
          // data from rootFields or meta.submeta
          options = value
        }
        
        options = options.filter( o => o !== "null" )
        
        options = options.sort( ( a, b ) => {
          let confA = categoryStore.getFieldConfigForKey( key, a )
          let confB = categoryStore.getFieldConfigForKey( key, b )
          
          let sortA = confA && confA.sort
          let sortB = confB && confB.sort
          
          // alphabetically sort
          let s1 = sortA || a
          let s2 = sortB || b
          if ( s1 > s2 ) return 1
          if ( s1 === s2 ) return 0
          if ( s1 < s2 ) return -1
        } )
        
        const metaData = cmsStore.config[ `${key}ByKey` ]
        
        if ( metaData ) {
          options = _.sortBy( options, entry => {
            const data = metaData[ entry ]
            return data && data.sort
          } )
        }
        const facettes = filterFieldsCurrentSearch && filterFieldsCurrentSearch[ key ] && filterFieldsCurrentSearch[ key ].values
        if ( !facettes ) return null
        return <FilterSegment
          filter={filter}
          facettes={facettes}
          hidden={hidden}
          defaultOpen={true}
          key={key}
          query={query}
          name={key}
          title={translate( filter.displayName )}
          options={options}/>
      } )}
      
      {/*<AccordionSegment defaultOpen={true} title={translate( "Kategorie" )} value={false} className={"unlimited-h"}>*/}
      {/*	<NavigationSidebar category={category} showTitle={false} />*/}
      {/*</AccordionSegment>*/}
    
    </Accordion>
  </div>
}


@withRouter
class AccordionSegment extends Component {
  
  state = {
    isActive: this.props.defaultOpen,
  }
  
  handleClick = () => {
    this.setState( { isActive: !this.state.isActive } )
  }
  
  handleClear = () => {
    this.props.history.replace( `/collection/` )
  }
  
  render() {
    const { isActive } = this.state
    const { title, value, children, className } = this.props
    return <Menu.Item className={`FilterSegment ${className} ${isActive ? "filter-active" : "filter-passive"} `}>
      {value && <Button className="clear-filter primary animate fadeIn" floated="left" circular icon={"close"} size="tiny"
                        onClick={this.handleClear}/>}
      <Accordion.Title
        active={isActive}
        content={title}
        onClick={this.handleClick}/>
      {(value) && <div className="active-value pl3 animate fadeIn pv2 black-50 f7">{value}</div>}
      <Accordion.Content active={isActive}>
        {children}
      </Accordion.Content>
    </Menu.Item>
  }
}

@withRouter
class FilterSegment extends Component {
  
  state = {
    isActive: this.props.defaultOpen, showFull: false
  }
  
  handleClick = () => {
    this.setState( { isActive: !this.state.isActive } )
  }
  
  handleClear = () => {
    const { name, query, options } = this.props
    delete query[ name ]
    this.props.history.replace( { search: queryString.stringify( query ) } )
  }
  
  render() {
    const { isActive, showFull } = this.state
    const { title, facettes, filter = {}, name, query, options, hidden = false, filterConfig = { multi: true } } = this.props
    const { fieldData = {} } = filter
    const { sort, extras = {} } = fieldData
    const value = query[ name ]
    
    let displayName = value
    if ( Array.isArray( value ) ) {
      displayName = value.join( ", " )
    }
    
    const OPTIONS_REDUCED_SIZE = 5
    const type = extras.type || "Checkbox"
    let optionsReduced = options
    let hasMoreOptions = options.length > OPTIONS_REDUCED_SIZE
    
    if ( !showFull && options.length > OPTIONS_REDUCED_SIZE ) {
      optionsReduced = options.slice( 0, 5 )
    }
    
    if ( hidden ) return null
    const filterSlug = slugify( title )
    return <React.Fragment>
      <Menu.Item className={`FilterSegment filter-${filterSlug} bb b--black-30`}>
        {/*<span className="red dib pr2">({sort})</span>*/}
        {/*{hidden && <span className={"f7 white bg-red pa1 "}>{name}</span>}*/}
        <div className="flex flex-row justify-between items-center pt2">
          <div className="w-100">
            {value && <Button className="clear-filter primary" floated="left" circular icon={"close"} basic size="tiny" onClick={this.handleClear}/>}
            <Accordion.Title
              active={isActive}
              content={<TruncatedTitle title={title} length={25} className={"b black-80 f5 "}/>}
              onClick={this.handleClick}/>
          </div>
        
        </div>
        {(!isActive && value) && <div className="active-value pl3 animate fadeIn pv2 black-50 f7">{displayName}</div>}
        {isActive && <Accordion.Content active={isActive}>
          <FilterForm
            facettes={this.props.facettes}
            type={type}
            options={optionsReduced}
            name={name}
            query={query}
            multi={filterConfig.multi}/>
          {hasMoreOptions && <React.Fragment>
            <div className="pv3">
              <a href={"#!"} onClick={() => {
                this.setState( { showFull: !this.state.showFull } )
              }} className={"f7 black dib b pv1  "}>
                {showFull && <span className="black-50">{translate( "Weniger anzeigen" )}</span>}
                {!showFull && <span className="black-50">{translate( "Alle anzeigen" )}</span>}
                <span className="black-60"><Icon name={"chevron right"}/></span></a>
            </div>
          
          
          </React.Fragment>}
        </Accordion.Content>}
      </Menu.Item>
    </React.Fragment>
  }
}

let lastFilter = false

const TruncatedTitle = ( { title, length, className = "" } ) => {
  if ( title.length > length ) {
    return <div className={className}>{title.substr( 0, length )}...</div>
  } else {
    return <div className={className}>{title}</div>
  }
}

const getDefaultFilterSearch = ( query = {} ) => {
  query.sort = query.sort || shop.config.standards.SORT || "des"
  query.dir = query.dir || shop.config.standards.DIR || "desc"
  return lastFilter || `?${queryString.stringify( query )}`
}

const SelectCount = ( { count = shop.config.standards.ITEMS_PER_PAGE, onChange } ) => (<Dropdown trigger={<span className="fw9">{count}</span>}>
  <Dropdown.Menu>
    <Dropdown.Item onClick={() => {
      onChange( "12" )
    }} text="12"/>
    <Dropdown.Item onClick={() => {
      onChange( "24" )
    }} text="24"/>
    <Dropdown.Item onClick={() => {
      onChange( "48" )
    }} text="48"/>
    <Dropdown.Item onClick={() => {
      onChange( "64" )
    }} text="64"/>
  </Dropdown.Menu>
</Dropdown>)


const SortBy = ( { sort, onChange } ) => (<Dropdown className="" style={{borderRadius: "35px", backgroundColor: "#ffffff"}}
  trigger={<span><span className="">{translate( "Sortierung" )}:</span> <span className="b">{sort == "des" || sort == "sort" ? translate("Alphabetisch") : translate("Art-Nr.")}</span></span>}>
  <Dropdown.Menu>
    {console.log("FILTER", sort)}
    {shop.session && <Dropdown.Item onClick={() => {
      onChange( "price" )
    }} text={translate("Preis")}/>}
    {/*<Dropdown.Item onClick={() => {
      onChange( "sort" )
    }} text="Standard"/>*/}
    <Dropdown.Item onClick={() => {
      onChange( "des" )
    }} text={translate("Alphabetisch")}/>

    <Dropdown.Item onClick={() => {
      onChange( "article_nr" )
    }} text={translate("Art-Nr.")}/>
    {/*    <Dropdown.Item onClick={() => {
      onChange( "creationdate" )
    }} text="Neuheit"/> */}
    {/*    <Dropdown.Item onClick={() => {
      onChange( "topseller" )
    }} text="Topseller"/> */}
  </Dropdown.Menu>
</Dropdown>)

class CategoryDropDownFilterPage extends React.Component {
  render() {
    const { fluid = true } = this.props;
    const { categories } = categoryStore;
    console.log("categories", categories)
    return (
      <Dropdown fluid={fluid} style={{ width: "140px" }} item text={<span className="pre pr2">{translate("Zur Startseite")}</span>}>
        <Dropdown.Menu>
          <Dropdown.Item text={<span className="pre ">{translate("Zur Startseite")}</span>} as={Link} to={"/home"} />
          <Divider />
          {categories.map(category => (
            <Dropdown.Item key={category.map_id} text={category.title} as={Link} to={`/collection/${category.map_id}`} />
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}


/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject( item ) {
  return (item && typeof item === 'object' && !Array.isArray( item ));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep( target, ...sources ) {
  if ( !sources.length ) return target;
  const source = sources.shift();
  
  if ( isObject( target ) && isObject( source ) ) {
    for ( const key in source ) {
      if ( isObject( source[ key ] ) ) {
        if ( !target[ key ] ) Object.assign( target, { [ key ]: {} } );
        mergeDeep( target[ key ], source[ key ] );
      } else {
        Object.assign( target, { [ key ]: source[ key ] } );
      }
    }
  }
  
  return mergeDeep( target, ...sources );
}



// WEBPACK FOOTER //
// ./src/theme/demo2025/pages/FilterPage.js